export const GET_ALL_TASKS = "/v2/tasks/all";
export const GET_ALL_COMPLETED_TASKS = "/v2/tasks/completed";
export const CREATE_TASK = "/v2/tasks/create";
export const UPDATE_TASK = "/v2/tasks/update";
export const DELETE_TASK = "/v2/tasks/delete";
export const GET_ALL_USERS = "/v1/user/list";